import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../icons";
import { ThermalScanRecord, listThermalScans } from "../../../api";

export function BorderSentinelPanel() {
  const { t, i18n } = useTranslation("dashboard");
  const [last, setLast] = useState<ThermalScanRecord | null>(null);

  useEffect(() => {
    const tick = async () => {
      try {
        const rows = await listThermalScans();
        setLast(rows[0] ?? null); // backend sorts by scanned_at desc
      } catch {
        // silent
      }
    };
    void tick();
    const t = setInterval(tick, 15_000);
    return () => clearInterval(t);
  }, []);

  const personDetected = !!last?.person_detected;
  const verdict = !last
    ? t("panels.border.awaitingScan")
    : personDetected
      ? t("panels.border.personDetected")
      : t("panels.border.noPerson");
  return (
    <>
      <header className="panel-head">
        <h3>
          <Icon name="thermometer" size={18} /> {t("panels.border.title")}
        </h3>
        <span className="panel-tag">
          {last ? new Date(last.scanned_at).toLocaleTimeString(i18n.resolvedLanguage) : "—"}
        </span>
      </header>
      <div className="border-body">
        <div className="border-thermal">
          <div className="thermal-overlay">
            <div className="thermal-grid" />
            <div className="thermal-hotspot thermal-hot-1" />
            <div className="thermal-hotspot thermal-hot-2" />
          </div>
          <div className={`thermal-result ${personDetected ? "" : "thermal-ok"}`}>
            <Icon name={personDetected ? "alert" : "check"} /> {verdict}
          </div>
        </div>
        <div className="border-meta">
          <div className="border-row">
            <span>{t("panels.border.lastScan")}</span>
            <strong>{last ? new Date(last.scanned_at).toLocaleString(i18n.resolvedLanguage) : "—"}</strong>
          </div>
          <div className="border-row">
            <span>{t("panels.border.location")}</span>
            <strong>{last?.location_label ?? "—"}</strong>
          </div>
          <div className="border-row">
            <span>{t("panels.border.maxTemp")}</span>
            <strong>
              {last?.max_temp_c != null ? `${last.max_temp_c.toFixed(1)} °C` : "—"}
            </strong>
          </div>
          <div className="border-row">
            <span>{t("panels.border.confidence")}</span>
            <strong>
              {last?.confidence != null
                ? `${(last.confidence * 100).toFixed(0)}%`
                : "—"}
            </strong>
          </div>
        </div>
      </div>
    </>
  );
}
